<div class="text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">Add Nodes</h4>
    <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
  </div>

  <div class="modal-body">
    <form spellcheck="false" autocomplete="off" [formGroup]="addNodeForm" (ngSubmit)="onSubmit(addNodeForm)">

      <mat-form-field style="width: 48%;">
        <mat-label>Enter Node Name</mat-label>
        <input matInput
               title="Enter Node Name"
               formControlName="poolname"
               placeholder="Node Prefix Name" />
        <mat-error *ngIf="
            addNodeForm.get('poolname').touched &&
            addNodeForm.get('poolname').errors?.required
          ">
          Enter Computer Prefix Name
        </mat-error>
      </mat-form-field>

      <mat-form-field style="width: 48%">
        <mat-label>Select Template</mat-label>
        <mat-select formControlName="template">
          <mat-option *ngFor="let temp of templateList" value="{{temp?.templateName}}">{{temp?.templateName}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field style="width: 48%;">
        <mat-label>Enter Number of Nodes</mat-label>
        <input matInput
               title="Enter Number of Nodes"
               formControlName="numofnodes"
               placeholder="Number of nodes" />
        <mat-error *ngIf="
            addNodeForm.get('numofnodes').touched &&
            addNodeForm.get('numofnodes').errors?.required
          ">
          Enter Number of Nodes
        </mat-error>
      </mat-form-field>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onClose()">Close</button>
    <button type="button" class="btn btn-primary"
            [disabled]="!addNodeForm.valid || isFormSubmitted == true"
            (click)="onSubmit(addNodeForm)">
      Submit
    </button>
  </div>
</div>
<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="default"
             zIndex="1"
             color="var(--s-primary-color)"
             type="ball-spin"
             [fullScreen]="false"
             name="addNode"><p class="pleaseWait">Please wait ...</p></ngx-spinner>
